import { render, staticRenderFns } from "./flightReservationMonitor.vue?vue&type=template&id=f164d172&scoped=true&"
import script from "./flightReservationMonitor.vue?vue&type=script&lang=ts&"
export * from "./flightReservationMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./flightReservationMonitor.vue?vue&type=style&index=0&id=f164d172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f164d172",
  null
  
)

export default component.exports